import lang from "@/views/modules/ReviewerDocuments/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-example",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            example: {},
            lang:[],
        }
    },
    mounted() {
        this.getReviewerDocuments();
        this.lang = lang;
    },
    methods: {
        saveReviewerDocuments() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/reviewerdocuments/' + self.$route.params.id, self.example).then(function () {
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        getReviewerDocuments() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/reviewerdocuments/' + self.$route.params.id).then(function (response) {
               // self.example = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}